// extracted by mini-css-extract-plugin
export default {"templateCard":"TemplateCard_templateCard__CF1r+","selected":"TemplateCard_selected__dXUsv"};